export const VERSION = '1.0.3';

export const SORT_TYPE = {
  DESC: 'desc',
  ASC: 'asc',
};

export const SORT = {
  DATE: 'date',
  TYPE: 'type',
};
